/* Badge styles */
.badge {
    padding: 0.25rem;
    font-size: var(--mantine-font-size-xs);
    font-weight: 600;
    text-transform: none;
    border-radius: 2px;
    background-color: var(--mantine-color-success-5);
    color: var(--mantine-color-dark-9);
}

.selectedBadge {
    padding: 0.25rem;
    font-size: var(--mantine-font-size-xs);
    font-weight: 600;
    text-transform: none;
    border-radius: 2px;
    background-color: var(--mantine-color-primary-1);
    color: var(--mantine-color-primary-9);
}

/* Plan Name styles */
.planNameRoot {
    object-fit: contain;
    object-position: left center;
}

.fullPlanCard {
    grid-column: span 2;
}

.planCardSelected {
    --gradient-overlay: linear-gradient(135deg, rgba(103, 0, 184, 0.08), rgba(169, 10, 211, 0.08));
    background: var(--gradient-overlay), var(--mantine-color-dark-4);
    border: 1px solid #8537c5;
    display: flex;
    flex-direction: column;
    height: 136px;
    cursor: pointer;
    padding: 12px 0 0 12px;
}

.badge {
    color: black;
    padding: 2px 10px;
}

.cardContainer {
    display: flex;
    flex-direction: column;
    height: 136px;
    cursor: pointer;
    padding: 12px 0 0 12px;
    background: var(--mantine-color-dark-4);
    border: 1px solid transparent;
}
.selected {
    background: #271a34;
    border: 1px solid #8537c5;
}

.declined {
    background-color: color-mix(in srgb, var(--mantine-color-dark-1), transparent 88%);
}

.enrolled {
    background-color: #087f5b14;
}

.cardText {
    color: var(--mantine-color-gray-0);
}

.planDispositionText {
    color: var(--mantine-color-gray-0);
    padding-left: 4px;
    margin-left: 4px;
}

.offerStatusSection {
    position: absolute;
    bottom: 10px;
    left: 10px;
}

.planImageSection {
    position: relative;
    align-self: self-end;
    bottom: 0;
}

.hidden {
    visibility: hidden;
}

.logo {
    max-height: 50px;
}

.enrolledBadge {
    background-color: var(--mantine-color-success-9);
    color: var(--mantine-color-success-0);
    padding: 0.25rem;
    font-size: var(--mantine-font-size-xs);
    font-weight: 600;
    text-transform: none;
    border-radius: 2px;
}

.declinedBadge {
    background-color: color-mix(in srgb, var(--mantine-color-dark-1), transparent 88%);
    color: color-mix(in srgb, var(--mantine-color-dark-1), transparent 30%);
    padding: 0.25rem;
    font-size: var(--mantine-font-size-xs);
    font-weight: 600;
    text-transform: none;
    border-radius: 2px;
}
